import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';
import uiButton from 'angular-ui-bootstrap/src/buttons';

// Dependencies
import '../../../../../lib/service';
import eventInfo from '../../../../../lib/components/eventInfo';
import primaryClaimEditor from '../primaryClaimEditor';
import secondaryClaimEditor from '../secondaryClaimEditor';
import confirmModal from '../../../../../lib/components/modals/confirmModal';
import errorList from '../../../../../lib/components/errorList';
import { DEBUG } from '../../../../../lib/constants';
import translationModuleName from '../../../../../lib/translation';

// Controller
import NetworkSettingsModalController from './networkSettingsModal.controller';
import template from './networkSettingsModal.html';

const moduleName = 'staff.dashboardScreen.networkSettingsModal';
let module = angular.module(moduleName, [
  uiModal,
  uiButton,
  'recaps.services',
  'constants',
  eventInfo.name,
  primaryClaimEditor.name,
  secondaryClaimEditor.name,
  confirmModal.name,
  errorList.name,
  translationModuleName,
]);

module.controller('NetworkSettingsModalController', NetworkSettingsModalController);

module.factory('showNetworkSettingsModal', ['$uibModal', '$q', ($uibModal, $q) => {
  return props => {
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: NetworkSettingsModalController,
      controllerAs: 'vm',
      size: 'sm',
      resolve: {
        $q: () => $q,
        DEBUG: () => DEBUG,
        staffUser: () => props.staffUser,
      }
    });
    return modal.result;
  };
}]);

export default module;
